import { CommandDispatcher } from '../../shared/domain/CommandDispatcher'
import { ViesValidationResult } from '../domain/ViesValidatorDomain'

export class ViesValidatorInfra {
  constructor(private readonly dispatcher: CommandDispatcher) {}

  async validate(cif: string): Promise<ViesValidationResult> {
    const response = await this.dispatcher.dispatch('invoices.vies.validation', { cif })
    return ViesValidationResult.from(response.output || {})
  }
}
